import type { FaireProductEntity } from "../../entity_types/product";

export const matcha_12: FaireProductEntity = {
  token: "matcha-12",
  type: "product",
  name: "Purely Matcha",
  brandName: "lake&oak",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/1196aa70d34804b318d197a5564b326538e72797f4b8bda8bdf244d7c84a1d68.png",
  priceDollars: 3,
  freeShipping: false,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/1196aa70d34804b318d197a5564b326538e72797f4b8bda8bdf244d7c84a1d68.png",
  weight: 0.2,
  dimensions: {
    width: 3,
    height: 5,
    depth: 2,
  },
  description: "Pure matcha powder from lake&oak",
  categoryTokens: ["cat_food-beverages"],
  tags: ["matcha", "tea", "japanese-green-tea", "organic", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
